import React from 'react';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import WhyChooseUs from './components/WhyChooseUs/WhyChooseUs';
import Gallery from './components/Gallery/Gallery';
import Reviews from './components/Reviews/Reviews';
import FAQ from './components/FAQ/FAQ';
import ServiceAreas from './components/ServiceAreas/ServiceAreas';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyChooseUs />
        <Gallery />
        <Reviews />
        <FAQ />
        <ServiceAreas />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
